"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { House, Landmark, Users, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const continuityPillars = [{
  title: "Real Estate Title",
  description: "How real estate is titled can affect whether an ownership interest becomes part of the probate estate or passes to a surviving owner.",
  icon: House
}, {
  title: "Financial Accounts & Beneficiary Designations",
  description: "Beneficiary designations may affect the transfer of certain financial accounts, retirement assets, annuities, insurance proceeds, and similar assets.",
  icon: Landmark
}, {
  title: "Trusts & Joint Ownership",
  description: "Assets properly held in trust or under certain survivorship ownership arrangements may pass outside probate, depending upon the governing documents, applicable law, and the particular form of ownership.",
  icon: Users
}];
export default function AssetAndContinuityEducation() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const businessReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const ctaReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="assetandcontinuityeducation" className="bg-background py-12 lg:py-20 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        
        {}
        <div ref={headerReveal.ref} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ease-out ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Badge variant="outline" className="mb-6 border-secondary text-secondary-foreground bg-secondary/10 px-4 py-1.5 text-sm font-medium tracking-wide">
            OWNERSHIP & BENEFICIARY DESIGNATIONS
          </Badge>
          <h2 className="text-2xl md:text-3xl font-default font-semibold text-foreground mb-4 leading-tight">
            How Assets May Pass
          </h2>
          <p className="text-muted-foreground leading-relaxed">The treatment of an asset depends on its legal title, beneficiary designations, joint ownership, trust ownership, applicable probate law, and the governing documents that determine how the asset is administered or transferred.</p>
        </div>

        {}
        <div ref={gridReveal.ref} className={`grid grid-cols-1 md:grid-cols-3 gap-8 mb-16 transition-all duration-700 delay-200 ease-out ${gridReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {continuityPillars.map((pillar, i) => <Card key={i} data-index={i} className="bg-card border-border shadow-sm hover:shadow-md transition-shadow duration-300 h-full flex flex-col">
              <CardHeader className="pb-4">
                <div className="size-12 rounded-lg bg-primary/5 flex items-center justify-center mb-4">
                  <pillar.icon className="size-6 text-primary" />
                </div>
                <CardTitle className="text-xl font-default text-foreground">{pillar.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground leading-relaxed">
                  {pillar.description}
                </p>
              </CardContent>
            </Card>)}
        </div>

        {}
        <div ref={businessReveal.ref} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 delay-300 ease-out ${businessReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <Link to="/BusinessCorporateServicesPage" className="text-xs text-muted-foreground hover:text-foreground transition-colors inline-flex items-center gap-1.5">
              Business & Corporate Services →
            </Link>
            <Link to="/RealEstateTransactionsPage" className="text-xs text-muted-foreground hover:text-foreground transition-colors inline-flex items-center gap-1.5">
              Real Estate Transactions →
            </Link>
          </div>
        </div>

        {}
        

      </div>
    </section>;
}